import type { SVGProps } from "react";
export interface CartXmarkIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CartXmarkIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CartXmarkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M22.135 2.882c.616.075 1.057.636.983 1.253l-.99 8.238a3.126 3.126 0 0 1-3.102 2.753H6.25a1.125 1.125 0 0 1 0-2.25h12.776a.876.876 0 0 0 .869-.771l.987-8.24a1.127 1.127 0 0 1 1.253-.983"
      />
      <path
        fill={color}
        d="M18.5 21.128a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zm1 .743a.6.6 0 0 0 .112-.245l.013-.126-.013-.126a.6.6 0 0 0-.111-.246zm-10.888-.497a.6.6 0 0 0-.112-.247v.745a.6.6 0 0 0 .112-.246l.013-.126zM7.5 21.127a.62.62 0 0 0-.125.373l.013.126a.6.6 0 0 0 .112.246zM2.34.875a3.125 3.125 0 0 1 3.072 2.549l2.235 11.922c.167.887.94 1.53 1.843 1.53H20l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.005H9.49a4.126 4.126 0 0 1-4.055-3.364L3.2 3.838a.875.875 0 0 0-.86-.713H2a1.125 1.125 0 0 1 0-2.25zm12.864 2.83a1.125 1.125 0 1 1 1.59 1.59L15.09 7l1.705 1.705.078.085a1.125 1.125 0 0 1-1.583 1.583l-.086-.078L13.5 8.59l-1.704 1.705a1.125 1.125 0 1 1-1.59-1.59L11.908 7l-1.703-1.704-.078-.087a1.125 1.125 0 0 1 1.583-1.582l.085.078L13.5 5.41l1.705-1.704ZM9.624 21.5a1.624 1.624 0 0 1-3.241.166l-.008-.166.008-.166A1.625 1.625 0 0 1 8 19.875l.166.008c.82.083 1.459.775 1.459 1.617Zm11.001 0a1.625 1.625 0 0 1-3.241.166l-.009-.166.009-.166A1.624 1.624 0 0 1 19 19.875l.166.008c.82.083 1.46.776 1.46 1.617Z"
      />
    </svg>
  );
}
